module.exports = __webpack_public_path__ + "img/best.af190c18.png";